import { render, staticRenderFns } from "./customer-details.vue?vue&type=template&id=0051ee1a&"
import script from "./customer-details.vue?vue&type=script&lang=js&"
export * from "./customer-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports